export default {
  titleCrossSell: {
    id: 'funnel_cart_cross_sell_title',
    defaultMessage: 'In case you need them',
  },
}
